import { render, staticRenderFns } from "./BoxCanvas.vue?vue&type=template&id=60df09c2&scoped=true"
import script from "./BoxCanvas.vue?vue&type=script&lang=js"
export * from "./BoxCanvas.vue?vue&type=script&lang=js"
import style0 from "./BoxCanvas.vue?vue&type=style&index=0&id=60df09c2&prod&scoped=true&lang=css"
import style1 from "./BoxCanvas.vue?vue&type=style&index=1&id=60df09c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df09c2",
  null
  
)

export default component.exports